import { render } from "./ServiceDetailFormModal.vue?vue&type=template&id=0fe7508b"
import script from "./ServiceDetailFormModal.vue?vue&type=script&lang=js"
export * from "./ServiceDetailFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__